import React from 'react';
import FieldError from '../Fragments/FieldError';
import FieldValidation from '../Fragments/FieldValidation';
import InputElement from 'react-input-mask';

let Validation = require('../Managers/Validation.js');
let Quote = require('../Managers/Quote');

const SortcodeInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        inputMask:  React.PropTypes.string.isRequired,
    },

    getDefaultProps() {
        return {
            inputMask: '99'
        };
    },

    getInitialState() {
        return {
            isHelpVisible: false,
            isValid: false,
            hasError: false,
            errors: null,
        };
    },

    setActiveValue(event) {
        let sortcode1 = document.getElementById(this.props.fieldName + '-1').value;
        let sortcode2 = document.getElementById(this.props.fieldName + '-2').value;
        let sortcode3 = document.getElementById(this.props.fieldName + '-3').value;
        let sortcode = sortcode1 + sortcode2 + sortcode3;
        let validation = Validation.validate(this.props.fieldName, sortcode)[0];
        this.setState(validation);
        if (event.target.name != this.props.fieldName + '-3') {
            this.setState({
                hasError: false
            });
        }
        if (validation.isValid) {
            this.setState({
                activeValue: sortcode,
                isValid: true
            });
            Quote.set(this.props.fieldName, sortcode);
        } else {
            Quote.set(this.props.fieldName, "");
        }
    },

    helpVisibility() {
        if (this.state.isHelpVisible) {
            this.setState({
                isHelpVisible: false,
            });
        } else {
            this.setState({
                isHelpVisible: true,
            });
        }
    },

    render() {
        return (
            <question-row>
                <div className="question-main">
                    <div className="question-top">
                        <label htmlFor={this.props.fieldName}>{this.props.question}</label>
                    </div>

                    <div className="question-input">
                        <div className="sortcode-group">
                            <InputElement
                                name={this.props.fieldName + '-1'}
                                id={this.props.fieldName + '-1'}
                                className="form-control"
                                mask={this.props.inputMask}
                                maskChar={null}
                                onBlur={this.setActiveValue}
                            />

                            <InputElement
                                name={this.props.fieldName + '-2'}
                                id={this.props.fieldName + '-2'}
                                className="form-control"
                                mask={this.props.inputMask}
                                maskChar={null}
                                onBlur={this.setActiveValue}
                            />

                            <InputElement
                                name={this.props.fieldName + '-3'}
                                id={this.props.fieldName + '-3'}
                                className="form-control"
                                mask={this.props.inputMask}
                                maskChar={null}
                                onBlur={this.setActiveValue}
                            />
                        </div>
                        {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                    </div>
                </div>
                <div className="question-extra">
                    <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                </div>
            </question-row>
        );
    }
});

export default SortcodeInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/SortcodeInput.js
 **/